// Recalc the price when the variant is changed
document.addEventListener('DOMContentLoaded', function () {
  const priceElement = document.querySelector('.price-item.price-item--regular'); // 価格表示要素を指定
  const howdyPriceElement = document.querySelector('#howdy-price-json');
  const comparePriceElement = document.querySelector('.price__sale .price-item.price-item--regular');
  const salePriceElement = document.querySelector('.price__sale .price-item.price-item--sale');

  // Howdy価格データを取得
  if (!howdyPriceElement) {
    // console.log('Howdy price data not found');
    return;
  }

  let howdyPriceData;
  try {
    howdyPriceData = JSON.parse(howdyPriceElement.textContent);
    // console.log('howdyPriceData', howdyPriceData);
  } catch (error) {
    // console.log('Error parsing Howdy price data:', error);
    return;
  }

  // 適切なバリアントデータを取得する関数
  function getTargetVariantData() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get('variant');
    // console.log('variantParam', variantParam);

    if (variantParam) {
      // variant paramがある場合、該当するバリアントを検索
      const targetVariant = howdyPriceData.variants.find(v => v.id == variantParam);
      if (targetVariant) {
        // console.log('Found variant from URL param:', targetVariant);
        return targetVariant;
      } else {
        // console.log('Variant not found for param:', variantParam);
      }
    }

    // variant paramがない場合、またはバリアントが見つからない場合はデフォルトバリアントを使用
    const defaultVariant = howdyPriceData.variants.find(v => v.is_default_variant === true);
    if (defaultVariant) {
      // console.log('Using default variant:', defaultVariant);
      return defaultVariant;
    }

    // デフォルトバリアントも見つからない場合は最初のバリアントを使用
    // console.log('Using first variant as fallback');
    return howdyPriceData.variants[0];
  }

  // 初期価格を設定
  function setInitialPrice() {
    const targetVariant = getTargetVariantData();
    if (targetVariant && salePriceElement) {
      // console.log('Setting initial Howdy price:', targetVariant.howdy_price);
      salePriceElement.textContent = targetVariant.howdy_price;
    }
  }

  // 初期価格を設定
  setInitialPrice();

  // MutationObserver Callback
  const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        // console.log("mutation occurred");

        // Stop observing
        observer.disconnect();

        // 現在のバリアントデータを取得して価格を更新
        const targetVariant = getTargetVariantData();
        if (targetVariant) {
          // console.log('Updating price after mutation:', targetVariant.howdy_price);
          if (salePriceElement) {
            salePriceElement.textContent = targetVariant.howdy_price;
          }
          if (comparePriceElement && targetVariant.howdy_compare_price) {
            comparePriceElement.textContent = targetVariant.howdy_compare_price;
          }
        }

        // Start observing again
        observer.observe(priceElement, config);
      }
    });
  });

  // Observe config
  const config = { childList: true, subtree: false };
  // Start observing
  if (priceElement) {
    observer.observe(priceElement, config);
  }
});